import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { UnauthorizedContent } from '@cp-mx/common';
import { fetchUnauthorized } from './UnauthorizedSlice';
import { UnauthorizedContentSelector } from './UnauthorizedContentSelector';

export function useUnauthorized(): AbstractContentState<UnauthorizedContent> {
    return useCmsContent(fetchUnauthorized, UnauthorizedContentSelector);
}
